import styled, { css } from 'styled-components';
import { fontSmoothing } from '@finect/tabular-utils/fontSmoothing';
var getStyles = function getStyles(theme, color) {
  switch (color) {
    case 'dark':
      return css(["background-color:", ";", ";color:#fff;"], theme.colors.uiDD, fontSmoothing);
    case 'grey':
      return css(["background-color:", ";"], theme.colors.uiLL);
    default:
      return css(["background-color:", ";"], theme.colors.background);
  }
};
export var Section = styled.section.withConfig({
  displayName: "Section",
  componentId: "sc-10q2pn5-0"
})(["position:relative;padding:30px 0;", ";", ";text-align:", ";&:last-of-type{margin-bottom:0;}"], function (_ref) {
  var theme = _ref.theme,
    color = _ref.color;
  return getStyles(theme, color);
}, function (_ref2) {
  var color = _ref2.color;
  return color && 'margin: 30px 0;';
}, function (_ref3) {
  var textAlign = _ref3.textAlign;
  return textAlign ? textAlign : 'left';
});